import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EguardNavigationService } from './navigation.service';

@Component({
  selector: 'eguard-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EguardNavigationComponent {
  user: any;
  userStateSubscription: any;
  verticalNavigation: any[];
  horizontalNavigation: any[];

  @Input('layout') layout = 'vertical';

  constructor(private navigationService: EguardNavigationService) {
    this.GetUser();
    // navigationService.getNavigation('verticalNavItems');

    this.horizontalNavigation = navigationService.getNavigation('horizontalNavItems');
  }

  GetUser() {
    if (!this.user) {
      let userDetails = localStorage.getItem('userDetails');
      if (userDetails) {
        this.user = JSON.parse(userDetails);
        let allMenus = this.navigationService.getNavigation('verticalNavItems');
        let menu = allMenus.filter(menuItem => menuItem.role === this.user.role);
        this.verticalNavigation = menu[0].children;
        this.horizontalNavigation = menu[0].children;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/navigation.component.ts